import { LoginResponseDto, RefreshTokenResponseDto } from '@json-converter/shared-types';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AuthState {
  user: LoginResponseDto['user'] | null;
  accessToken: LoginResponseDto['accessToken'] | null;
  refreshToken: LoginResponseDto['refreshToken'] | null;
  isLoading: boolean;
  error: string | null;
  login: (data: LoginResponseDto) => void;
  logout: () => Promise<void>;
  updateTokens: (data: RefreshTokenResponseDto) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      user: null,
      accessToken: null,
      refreshToken: null,
      isLoading: false,
      error: null,
      login: (data: LoginResponseDto) => {
        set({ user: data.user, accessToken: data.accessToken, refreshToken: data.refreshToken });
        // apiClient.defaults.headers.common['Authorization'] = `Bearer ${data.accessToken}`;
      },
      logout: async () => {
        set({ user: null, accessToken: null, refreshToken: null, error: null });
        // delete apiClient.defaults.headers.common['Authorization'];
      },
      updateTokens: (data: RefreshTokenResponseDto) => {
        set({
          accessToken: data.accessToken,
          refreshToken: data.refreshToken,
        });
        // apiClient.defaults.headers.common['Authorization'] = `Bearer ${data.accessToken}`;
      },
    }),
    {
      name: 'auth-store',
      partialize: state => ({
        user: state.user,
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
      }),
    },
  ),
);
